import { render, staticRenderFns } from "./LibraryManager.vue?vue&type=template&id=234fdc20"
import script from "./LibraryManager.vue?vue&type=script&lang=js"
export * from "./LibraryManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports